<template>
    <div>
      <div class="supplement-step1-content">
        <span class="el-icon-success"></span>
        <span>{{$t('message.user.pleaseContinue')}}</span>
      </div>
      <div class="margin-top-20">
      <el-button
        style="width: 100%"
        type="primary"
        @click="onSubmit"
        >{{ $t("message.user.supplement") }}</el-button>
      </div>
    </div>
</template>

<script>
export default {
  methods: {
    onSubmit() {
      this.$emit('finish');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/element-variables.scss';
.supplement-step1-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 180px;
  margin-bottom: 90px;
  font-size: 16px;
  font-weight: 600;
  color: $color-text-primary;
  line-height: 22px;

  .el-icon-success {
    color: #00A2DD;
    font-size: 108px;
    line-height: 1;
    font-weight: normal;
    margin-bottom: 18px;
  }
}
</style>
